import { call, put, takeLatest } from 'redux-saga/effects'
import {
  updateAddressRequest,
  updateAddressSuccess,
  updateAddressError,
  getAppointmentSlotsRequest,
  getAppointmentSlotsSuccess,
  getAppointmentSlotsError,
  pushMssageToSnackbar,
  createLabTestOrderRequest,
  createLabTestOrderSuccess,
  createLabTestOrderError,
  confirmOrderRequest,
  confirmOrderSuccess,
  confirmOrderError,
  getRecordsRequest,
  getRecordsSuccess,
  getRecordsError,
} from '../slices'
import {
  bookTest,
  confirmOrder,
  getAppointmentSlots,
  getRecords,
  updateAddress,
} from '../../api'

// Worker Saga: Update Address
function* handleUpdateAddress(action) {
  try {
    const response = yield call(updateAddress, action.payload)
    yield put(updateAddressSuccess(response))
  } catch (error) {
    yield put(
      pushMssageToSnackbar({
        message: error.message || 'Unknown Error Occurred',
        type: 'error',
      }),
    )
    yield put(updateAddressError(error.message || 'Unknown Error Occurred'))
  }
}

// Worker Saga: Book Test
function* handleBookTest(action) {
  try {
    const response = yield call(bookTest, action.payload)
    yield put(createLabTestOrderSuccess(response))
  } catch (error) {
    yield put(
      pushMssageToSnackbar({
        message: error.message || 'Unknown Error Occurred',
        type: 'error',
      }),
    )
    yield put(
      createLabTestOrderError(error.message || 'Unknown Error Occurred'),
    )
  }
}

// Worker Saga: Get Appointment Slots
function* handleGetAppointmentSlots(action) {
  try {
    const response = yield call(getAppointmentSlots, action.payload)
    yield put(getAppointmentSlotsSuccess(response))
  } catch (error) {
    yield put(
      pushMssageToSnackbar({
        message: error.message || 'Unknown Error Occurred',
        type: 'error',
      }),
    )
    yield put(
      getAppointmentSlotsError(error.message || 'Unknown Error Occurred'),
    )
  }
}

// Worker Saga: Confirm Order
function* handleConfirmOrder(action) {
  try {
    const response = yield call(confirmOrder, action.payload)
    yield put(confirmOrderSuccess(response))
  } catch (error) {
    yield put(
      pushMssageToSnackbar({
        message: error.message || 'Unknown Error Occurred',
        type: 'error',
      }),
    )
    yield put(confirmOrderError(error.message || 'Unknown Error Occurred'))
  }
}

// Worker Saga: Get Records
function* handleGetRecords(action) {
  try {
    const response = yield call(getRecords, action.payload)
    yield put(getRecordsSuccess(response))
  } catch (error) {
    yield put(
      pushMssageToSnackbar({
        message: error.message || 'Unknown Error Occurred',
        type: 'error',
      }),
    )
    yield put(getRecordsError(error.message || 'Unknown Error Occurred'))
  }
}

// Watcher Saga
function* diagnosticsSaga() {
  yield takeLatest(updateAddressRequest.type, handleUpdateAddress)
  yield takeLatest(getAppointmentSlotsRequest.type, handleGetAppointmentSlots)
  yield takeLatest(createLabTestOrderRequest.type, handleBookTest)
  yield takeLatest(confirmOrderRequest.type, handleConfirmOrder)
  yield takeLatest(getRecordsRequest.type, handleGetRecords)
}

export default diagnosticsSaga
